<template>
    <div>
        <el-dialog v-if="dialogVisible" v-el-drag-dialog :title="$tx('hygl.components.changeRecord', '变更记录')" :visible.sync="dialogVisible" width="1000px" :close-on-click-modal="false" :destroy-on-close="true" @close="toClose">
            <div>
                <el-table ref="table" :data="tableData" border class="jxzb-tables">
                    <el-table-column type="index" :label="$tx('fields.index', '序号')" width="50" align="center"></el-table-column>
                    <el-table-column prop="personName" :label="$tx('hygl.components.personName', '操作人')" width="110" align="center" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="operateTime" :label="$tx('hygl.components.operateTime', '操作时间')" width="150" align="center" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="updateType" :label="$tx('hygl.components.updateType', '变更类型')" width="120" align="center" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="updateContent" :label="$tx('hygl.components.updateContent', '变更内容')" align="left"></el-table-column>
                </el-table>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button v-pageBtn-lbl="'close'" @click="toClose">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
const moment = require('moment')
export default {
    filters: {
        timeFormat(val) {
            return moment(val).format('YYYY-MM-DD HH:mm')
        }
    },
    components: {},
    props: {},
    data() {
        return {
            dialogVisible: false,
            tableData: []
        }
    },
    computed: {},
    watch: {},
    created() {
        this.$bus.on('openMeetChangeLog', this.openMeetChangeLog)
    },
    beforeDestroy() {
        this.$bus.off('openMeetChangeLog', this.openMeetChangeLog)
    },
    mounted() {},
    methods: {
        openMeetChangeLog(row) {
            console.log('row==', row)

            this.queryData(row.id)
        },
        async queryData(id) {
            const data = [{ compare: '=', field: 'meetId', merge: true, value: id }]
            const res = await this.$app.querydata('/hygl/meetUpdateLog/querydata', data, 'operateTime desc')
            if (res.code === 'success') {
                this.tableData = res.body.listdata
                this.dialogVisible = true
            } else {
                this.$message({ message: res.message, type: 'warning' })
            }
        },
        // 关闭
        toClose() {
            this.dialogVisible = false
        }
    }
}
</script>

<style scoped lang="scss">
.dialog_top {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    .el-button {
        margin-left: 10px;
        padding: 8px 15px;
    }
}
</style>
